import React from 'react';
import PropTypes from 'prop-types';
import { createSurveyStyles } from '@sm/webassets';
import { sanitizeString } from '@sm/utils';
import './survey-title.scss';

const useStyles = createSurveyStyles(theme => {
  return {
    surveyTitle: {
      ...theme?.surveyTitle,
      color: theme?.titleColor || theme?.surveyTitle?.color,
      padding: '40px 16px 8px',
    },
  };
});

const SurveyTitle = ({ title }) => {
  const { surveyTitle } = useStyles();
  return (
    <div
      className={`sm-survey-title--container ${surveyTitle}`}
      data-testid="SurveyTitle__Container"
      dangerouslySetInnerHTML={{ __html: sanitizeString(title) }}
    />
  );
};

SurveyTitle.propTypes = {
  title: PropTypes.string,
};

SurveyTitle.defaultProps = {
  title: '',
};

export default SurveyTitle;
